import { api } from "../../app/http/axiosClient.js";

export async function checkInTicket(ticketUuid) {
  const response = await api.post(`/tickets/check-in/${encodeURIComponent(ticketUuid)}`);
  return response.data;
}